import type { SipPlansCategory, SipStartRecommendation } from '../../../../api/sipPlan.types'
import { SipCategoryBucketKey, SIP_CATEGORY_BUCKET_TITLES, SipPlanMode, type SipActionFilter } from '../../../../api/types'
import { useSipPlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../../../lumpsum/plans-list/lumpsum-ui-components/BucketAccordion'
import { StartSipFundCard } from '../cards/StartSipFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansScreen, PlansSipListEventIds } from '../../../../../analytics/plansEvents'

type StartSipBucketAccordionProps = {
  category: SipPlansCategory
  categoryId: string
  actionFilter: SipActionFilter
  isBorderTop?: boolean
}

export function StartSipBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: StartSipBucketAccordionProps) {
  const startRecommendations = getCategoryBucketItems<SipStartRecommendation>(category?.startRecommendations)
  const { bucketCompositeKey, isExpanded, toggle } = useSipPlanCategoryBucket({
    planMode: SipPlanMode.YOUR_PLAN,
    actionFilter,
    categoryId,
    bucketKey: SipCategoryBucketKey.startRecommendations
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={SIP_CATEGORY_BUCKET_TITLES[SipCategoryBucketKey.startRecommendations]}
      count={startRecommendations.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.SipYourPlan,
            eventId: PlansSipListEventIds.BucketAccordion,
            buttonLabel: SIP_CATEGORY_BUCKET_TITLES[SipCategoryBucketKey.startRecommendations]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {startRecommendations.map((recommendation, recommendationIndex) => (
        <StartSipFundCard
          key={`${recommendation?.isin ?? 'fund'}-${recommendationIndex}`}
          recommendation={recommendation}
          showBottomDivider={recommendationIndex < startRecommendations.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
